import React from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType';
import {CFModel} from 'module/CustomField/type/CFType';
import {Switch} from '@mui/material'

export function JaNeinToggleComponent<M extends CFModel>({modelValue, disabled, setCb}: CFComponentProps<'J' | 'N'>) {
	const checked = modelValue === 'J';
	return (
		<Switch
			color={'primary'}
			checked={checked}
			disabled={disabled}
			onChange={() => !disabled && setCb(checked ? 'N' : 'J')}
		/>
	);
}